module.exports = __webpack_public_path__ + "img/Card_Punch_Blue-min.0d5ba325.png";